import TrendDirection from './TrendDirection';


export default TrendDirection;
